import { getDefaultTargetLanguage, getLanguageName } from "../app/utils/Language";

export default function() {
    return getLanguageName(getDefaultTargetLanguage());
}